import { z } from "zod"

const UnknownRecordSchema = z.record(z.unknown())

// ==========================================================================
// Group 3 - custom/*
// ==========================================================================

export const CustomFilledBoxesResponseSchema = z.array(z.number())

export const CustomGetBoxPublishDateResponseSchema = z.object({
  date: z.string(),
})

const CartListItemSchema = z.object({
  row_id: z.number(),
  user_email: z.union([z.string(), z.null()]),
  sum: z.union([z.number(), z.string()]),
  last_update: z.union([z.number(), z.string()]),
})

export const CustomCartsResponseSchema = z.union([
  z.literal(false),
  z.array(CartListItemSchema),
])

export const CustomGetOrdersUtmListResponseSchema = z.array(z.string())

export const CustomVisitShopPointsResponseSchema = z.array(
  z.object({
    m_item_id: z.string(),
    m_item_user_id: z.string(),
    m_item_email: z.string(),
    m_item_date: z.string(),
    m_item_time: z.string(),
  })
)

const PromocodeProductSchema = z.object({
  name: z.string(),
  price: z.union([z.number(), z.string()]),
  options: z
    .object({
      artist_name: z.string().optional(),
      type: z.string().optional(),
    })
    .passthrough(),
})

export const CustomPromocodeMessagesResponseSchema = z.array(
  z.object({
    row_id: z.string(),
    row_date: z.string(),
    code_name: z.string(),
    user_fullname: z.string(),
    user_email: z.string(),
    user_phone: z.string(),
    products: z.array(PromocodeProductSchema),
  })
)

const OracleProductSchema = z
  .object({
    artist_name: z.string().optional(),
    album: z.string().optional(),
    m_item_price: z.union([z.number(), z.string()]).optional(),
    m_item_title: z.string().optional(),
    m_item_album_tail: z.string().optional(),
  })
  .passthrough()

export const CustomGetOracleRequestsResponseSchema = z.array(
  z.object({
    m_item_id: z.union([z.number(), z.string()]),
    m_item_email: z.union([z.string(), z.null()]),
    m_item_text: z.string(),
    m_item_products: z.string(),
    m_item_date_created: z.union([z.number(), z.string()]),
    m_item_date_updated: z.union([z.number(), z.string(), z.null()]).optional(),
    m_item_manager: z.union([z.number(), z.string()]).optional(),
    lp: z.array(OracleProductSchema).optional(),
    cd: z.array(OracleProductSchema).optional(),
  })
)

export const RcmdListResponseSchema = z
  .object({
    status: z.number(),
    data: z.array(z.record(z.unknown())),
  })
  .strict()

const CashboxQueueRowSchema = z.object({
  row_id: z.union([z.number(), z.string()]),
  check_id: z.string(),
  product_id: z.union([z.number(), z.string()]).nullable(),
  product_type: z.string().optional(),
  artist: z.string().optional(),
  album: z.string().optional(),
  price: z.union([z.number(), z.string()]).optional(),
  qty: z.union([z.number(), z.string()]).optional(),
  orders: z.string(),
  copies: z.union([z.boolean(), UnknownRecordSchema]).optional(),
})

export const CustomGetCashboxQueueResponseSchema = z
  .object({
    errors: z
      .array(
        z.object({
          row_id: z.union([z.number(), z.string()]),
          check_id: z.string(),
          error: z.string(),
        })
      )
      .optional(),
    lp: z.array(CashboxQueueRowSchema),
    cd: z.array(CashboxQueueRowSchema),
  })
  .strict()

export const CustomGetCashboxErrorsResponseSchema = z.array(
  z.object({
    row_id: z.union([z.number(), z.string()]),
    check_id: z.string(),
    msg: z.string(),
    row_date: z.string(),
  })
)

export const CustomGetUserCollectionResponseSchema = z.array(
  z.object({
    m_item_id: z.union([z.number(), z.string()]),
    artist_name: z.string(),
    m_item_title: z.string(),
    m_item_year: z.string(),
    m_item_year_edition: z.string(),
    m_item_price: z.union([z.number(), z.string()]),
    f_dir: z.string(),
    m_item_list_img: z.string(),
    styles: z.array(z.object({ m_item_title: z.string() })),
  })
)

// ==========================================================================
// Group 3 - edit/services/* and marketprices/get
// ==========================================================================

export const Services1CDocumentsResponseSchema = z.array(
  z
    .object({
      Номер: z.string(),
      ДатаДокумента: z.string(),
      Контрагент: z.string(),
    })
    .strict()
)

export const Services1CTemplatesResponseSchema = z.array(
  z
    .object({
      Номер: z.string(),
      ДатаДокумента: z.string(),
      Шаблон: z.string(),
    })
    .strict()
)

export const Services1CSourcesResponseSchema = z.record(z.string())

export const ServicesSearchSalesResponseSchema = z.array(UnknownRecordSchema)

export const ServicesSalesReportResponseSchema = z.array(UnknownRecordSchema)

const MarketpriceValueSchema = z.union([z.string(), z.number()])
const MarketpriceLeafSchema = z
  .object({
    multi: MarketpriceValueSchema.optional(),
    price: MarketpriceValueSchema.optional(),
    value: MarketpriceValueSchema.optional(),
  })
  .passthrough()

const MarketpricesObjectSchema = z
  .object({
    suppliers: z.array(z.unknown()),
    prices: z.record(z.record(z.record(z.record(MarketpriceLeafSchema)))),
  })
  .strict()

const MarketpricesEmptySchema = z.array(z.never())

export const MarketpricesGetResponseSchema = z.union([
  MarketpricesObjectSchema,
  MarketpricesEmptySchema,
])

// Backward-compatible aliases
export const CustomBoxPublishDateResponseSchema =
  CustomGetBoxPublishDateResponseSchema
export const CustomUtmListResponseSchema = CustomGetOrdersUtmListResponseSchema
export const CustomOracleRequestsResponseSchema =
  CustomGetOracleRequestsResponseSchema
export const CustomCashboxQueueResponseSchema =
  CustomGetCashboxQueueResponseSchema
export const CustomCashboxErrorsResponseSchema =
  CustomGetCashboxErrorsResponseSchema
export const CustomUserCollectionResponseSchema =
  CustomGetUserCollectionResponseSchema
